module.exports = function(pages) {
	'use strict'
	pages.directive('pageDir',pageDir);
	pageDir.$inject=[];
	function pageDir() {
		return {
			template: require('./partial/edit-newPage.html'),
			controller:"pageController",
			controllerAs:"vmpg",
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pagesModule/edit-newpage/js/directive/pageDirective.js
// module id = 537
// module chunks = 0